import React, { useEffect, useState } from "react";
import Header from "../../Pages/Header";
import Footer from "../../Pages/Footer";
import ScrollToTop from "./ScrollToTop";

const Layout = ({ children }) => {
  const [scrollWidth, setScrollWidth] = useState(0);

  const handleScroll = () => {
    const totalHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const currentScroll = window.scrollY;
    const scrollPercentage = (currentScroll / totalHeight) * 100;
    setScrollWidth(scrollPercentage);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${scrollWidth}%` }}>
          <div className="star" />
        </div>
      </div>
      <div className="main-container">
        <Header />
        {children}
        <Footer />
      </div>
      <ScrollToTop />
    </>
  );
};

export default Layout;
